import axios from "axios";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { errorFormat } from "./handleError.utils";
import { getToken, removeToken } from "./token.utils";
import { removeAuth } from "../redux/slice/authSlice";
import { useEffect, useState } from "react";

// export const apiBaseUrl = `http://localhost:9000/api`;
export const apiBaseUrl = `https://officeapi.aurobilcars.com/api`;

const useAxiosInstance = () => {
  const axiosInstance = axios.create({
    baseURL: apiBaseUrl,
    headers: {
      "Content-type": "application/json"
    }
  });

  axiosInstance.interceptors.request.use(
    (config) => {
      const accessToken = getToken();
      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // State to manage the redirection
  const [redirectError, setRedirectError] = useState(false);

  // Response interceptor
  axiosInstance.interceptors.response.use(
    (response) => {
      // Do something with successful responses
      return response;
    },
    (error) => {
      // Check for 401 Unauthorized: then redirect to login page
      if (error?.response && error?.response?.status === 401) {
        setRedirectError(true);
      }
      // Optionally, you can throw an error or handle it in another way
      return Promise.reject(error);
    }
  );

  useEffect(() => {
    if (redirectError) {
      dispatch(removeAuth());
      removeToken();
      navigate("/login");
    }
  }, [dispatch, navigate, redirectError]);

  async function getApi(api) {
    try {
      const apiResponse = await axiosInstance.get(api);
      return {
        data: apiResponse?.data,
        status: apiResponse?.status,
        message: apiResponse?.statusText
      };
    } catch (error) {
      return errorFormat(error);
    }
  }

  async function postApi(api, data) {
    try {
      const apiResponse = await axiosInstance.post(api, data);
      return {
        data: apiResponse?.data,
        status: apiResponse?.status,
        message: apiResponse?.statusText
      };
    } catch (error) {
      return errorFormat(error);
    }
  }

  async function deleteApi(api) {
    try {
      const apiResponse = await axiosInstance.delete(api);
      return {
        data: apiResponse?.data,
        status: apiResponse?.status,
        message: apiResponse?.statusText
      };
    } catch (error) {
      return errorFormat(error);
    }
  }

  async function putApi(api, data) {
    try {
      const apiResponse = await axiosInstance.put(api, data);
      return {
        data: apiResponse?.data,
        status: apiResponse?.status,
        message: apiResponse?.statusText
      };
    } catch (error) {
      return errorFormat(error);
    }
  }

  return { axiosInstance, getApi, postApi, deleteApi, putApi };
};

export default useAxiosInstance;
